module.exports = __webpack_public_path__ + "static/media/white-go-4.ebc27754.svg";